import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';
import { catchError, map, of } from 'rxjs';

export const subscriptionGuard: CanActivateFn = (route, state) => {
  const subscriptionService = inject(SubscriptionService);
  const router = inject(Router);

  return subscriptionService.getSubscriptionStatus().pipe(
    map(status => {
      if (status.status === 'active') {
        return true;
      } else {
        // Subscription abgelaufen oder inaktiv - zur Expired-Seite
        router.navigate(['/subscription-expired']);
        return false;
      }
    }),
    catchError((error) => {
      console.error('Subscription check failed:', error);
      // Bei Fehler zur Landing Page
      router.navigate(['/']);
      return of(false);
    })
  );
};
